<h3 class="mt-0 mb-12">{{ userAttribute.translationKey | translate }}</h3>
<div class="slider-wrapper" *ngIf="isSliderVisible; else noSlider">
    <ngx-slider [(value)]="lowRangeSliderValue" [(highValue)]="highRangeSliderValue" [(options)]="options" (userChange)="valueChange($event)"></ngx-slider>
    <div fxLayoutAlign="space-between center">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'GENERAL.LABEL.MIN' | translate }}</mat-label>
            <input matInput [min]="options.floor" [max]="options.ceil" type="number" [formControl]="minValue" (change)="valueChange()" />
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{ 'GENERAL.LABEL.MAX' | translate }}</mat-label>
            <input matInput [min]="options.floor" [max]="options.ceil" type="number" [formControl]="maxValue" (change)="valueChange()" />
        </mat-form-field>
    </div>
</div>
<ng-template #noSlider>
    <div class="no-options-container" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="participant-view-illustration" svgIcon="opened_folder_2"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.MESSAGE.NO_DEFINED_VALUES' | translate }}</h2>
    </div>
</ng-template>
